import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';
import { getVideosByType } from '@/utils/videos';

export default function CategoryQuickEntry() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {categories.map((cat) => {
        const count = getVideosByType(cat.key).length;
        return (
          <Link
            key={cat.key}
            to={cat.path}
            className="group relative flex items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/50 transition-colors"
          >
            <span className="w-14 h-14 shrink-0 rounded-lg bg-primary-500/12 flex items-center justify-center text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950 transition-colors">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                {cat.name}
                <span className="ml-2 text-xs font-normal text-foreground-500">{count} 部内容</span>
              </h3>
              <p className="mt-1 text-xs text-foreground-600 line-clamp-2">{cat.desc}</p>
            </div>
            <span className="ml-auto w-8 h-8 shrink-0 flex items-center justify-center text-foreground-500 group-hover:text-primary-400 transition-colors">
              <i className="ri-arrow-right-line text-lg" />
            </span>
          </Link>
        );
      })}
    </section>
  );
}